//#region imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { CharacteristicsRoutingModule } from './characteristics-routing.module';
import { CharacteristicsQuestionComponent } from './components/characteristics-question/characteristics-question.component';
import { CharacteristicsQuestion1Component } from './components/characteristics-question1/characteristics-question1.component';
import { CharacteristicsQuestion2Component } from './components/characteristics-question2/characteristics-question2.component';
import { CharacteristicsQuestion3Component } from './components/characteristics-question3/characteristics-question3.component';
import { CharacteristicsQuestion4Component } from './components/characteristics-question4/characteristics-question4.component';
import { CharacteristicsQuestion5Component } from './components/characteristics-question5/characteristics-question5.component';
//#endregion

@NgModule({
  declarations: [
    CharacteristicsQuestionComponent, CharacteristicsQuestion1Component,
    CharacteristicsQuestion2Component, CharacteristicsQuestion3Component,
    CharacteristicsQuestion4Component, CharacteristicsQuestion5Component
  ],
  imports: [
    SharedModule, CommonModule,
    CharacteristicsRoutingModule
  ],
  exports: [
    CharacteristicsQuestionComponent, CharacteristicsQuestion1Component,
    CharacteristicsQuestion2Component, CharacteristicsQuestion3Component,
    CharacteristicsQuestion4Component, CharacteristicsQuestion5Component
  ]
})
export class CharacteristicsModule { }
